module.exports = __webpack_public_path__ + "img/2.e4319f6f.jpg";